import { PortalBaseService } from 'src/portal/portal-base.service';
import { Injectable } from '@angular/core';
import { PortalProfileModel } from './portal-profile.models';
import { State } from 'src/app/shared/models/state';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Country } from 'src/app/shared/models/country';

@Injectable({
  providedIn: 'root',
})
export class PortalProfileService extends PortalBaseService {
  public states: BehaviorSubject<State[]> = new BehaviorSubject<State[]>(null);
  public countries: BehaviorSubject<Country[]> = new BehaviorSubject<Country[]>(null);
  public getProfile(): Promise<PortalProfileModel> {
    return this.get<PortalProfileModel>('portal/profile').toPromise();
  }
  public getStates(): Promise<State[]> {
    return this.get<State[]>('v1/lookup/states')
      .pipe(
        map((states: State[]) => {
          if (!states || states.length === 0) return [];
          const stateModels = states.map((state) => State.parse(state));
          this.states.next(stateModels);
          return stateModels;
        })
      )
      .toPromise();
  }

  public getCountries(): Promise<Country[]> {
    return this.get<Country[]>('v1/lookup/countries')
      .pipe(
        map((countries: Country[]) => {
          if (!countries || countries.length === 0) return [];
          const countryModels = countries.map((country) => Country.parse(country));
          this.countries.next(countryModels);
          return countryModels;
        })
      )
      .toPromise();
  }
}
